var prd_slide = new Swiper('.prd_slide ', {
      slidesPerView: 1.2, 
      spaceBetween: 15, 
      navigation: {
      nextEl: ".next-btn2",
      prevEl: ".prev-btn2",
    },

      breakpoints: { //반응형 조건 속성
        640: { //640 이상일 경우
          slidesPerView: 1.2, 
        },
        1024: {
          slidesPerView: 3,
        
        },
        1400: {
          slidesPerView: 4,
       
        },
      }
});